import { Label, TextInput } from 'flowbite-react';
import React, { useState } from 'react';
import { CheckInLoginFormMeta, LoadingSpinnerMeta } from '../data'
import { Button, Card, LoadingSpinner, SplitBackgroundLayout } from '../components';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api';

function CheckInLoginForm() {
    const meta = CheckInLoginFormMeta
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState<string | null>(null)
    const [formData, setFormData] = useState({
        username: "",
        password: ""
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setLoading(true);

        const loginData = {
            username: formData.username,
            password: formData.password
        };

        try {
            const response = await fetch(API_BASE_URL + '/auth/checkin-login',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    credentials: 'include',
                    body: JSON.stringify(loginData)
                });

            const result = await response.json();

            if (!response.ok) {
                throw new Error(result.message || 'Login failed.');
            }
            else {
                window.location.href = result.redirect_path || "/admin/check-in";
            }

        } catch (err) {
            console.error('Login Failed:', err);
            setError(err.message || 'Invalid credentials.');

        } finally {
            setLoading(false);
        }
    };

    return (
        <SplitBackgroundLayout>
            {loading && (
                <div className="absolute top-4 flex justify-center items-center w-full">
                    <LoadingSpinner meta={LoadingSpinnerMeta} />
                </div>
            )}

            {error && (
                <div className="w-full max-w-sm mb-4">
                    <div className="bg-danger-500/10 border border-danger-500 text-danger-500 px-6 py-4 rounded-lg">
                        <p className="font-bold text-lg mb-2">{meta.errorLabel}</p>
                        <p>{error}</p>
                    </div>
                </div>
            )}

            <Card className="w-full max-w-sm shadow-lg p-4">

                        <h3 className="text-xl font-bold text-gray-900 dark:text-white text-center mb-0">
                            {meta.title}
                        </h3>

                        <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
                            {/* Username Input */}
                            <div>
                                <div className="mb-1 block">
                                    <Label htmlFor="username">{meta.usernameLabel}</Label>
                                </div>
                                <TextInput
                                    id="username"
                                    type="text"
                                    name="username"
                                    placeholder={meta.usernamePlaceholder}
                                    value={formData.username}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            {/* Password Input */}
                            <div>
                                <div className="mb-1 block">
                                    <Label htmlFor="password">{meta.passwordLabel}</Label>
                                </div>
                                <TextInput
                                    id="password"
                                    type="password"
                                    name="password"
                                    placeholder={meta.passwordPlaceholder}
                                    value={formData.password}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            {/* Login Button */}
                            <Button type="submit">
                                {meta.loginButton}
                            </Button>
                    </form>
                </Card>
        </SplitBackgroundLayout>
    );
}
export default CheckInLoginForm;
